import React, { useEffect, useState } from 'react';
import Dashboard from './Dashboard';
import Login from './Login';
import { clearSession, getToken, getUserName, onSignedOut } from './auth';
import './App.css';

/**
 * The dashboard is admin-only, so nothing renders until someone has signed in
 * with a WordPress administrator account (issue #4).
 *
 * The axios interceptors that carry the session token are installed when
 * `./auth` is imported, not here — a child's effects run before its parent's,
 * so installing them from this component let Dashboard's first requests escape
 * unauthenticated. All this effect does is say where a refusal should land.
 */
function App() {
  const [signedIn, setSignedIn] = useState<boolean>(() => getToken() !== null);
  const [userName, setUserName] = useState<string | null>(() => getUserName());

  useEffect(() => {
    onSignedOut(() => {
      setSignedIn(false);
      setUserName(null);
    });
  }, []);

  if (!signedIn) {
    return (
      <Login
        onSignedIn={(displayName) => {
          setUserName(displayName);
          setSignedIn(true);
        }}
      />
    );
  }

  return (
    <Dashboard
      userName={userName}
      onSignOut={() => {
        clearSession();
        setSignedIn(false);
        setUserName(null);
      }}
    />
  );
}

export default App;
